import type { OrganizationSettingFieldsFragment } from '@salescore/client-api'
import { type Period, periodUtil } from '@salescore/features'
import { parseJsonIfValid } from '@salescore/frontend-common'
import { Array, pipe } from 'effect'
import { isNotNullish } from 'effect/Predicate'
import { t } from 'i18next'

export type { Period } from '@salescore/features'

const PERIODS_CACHE_KEY = 'PERIOD_CACHE_KEY'
const getCachedPeriodNames = () => {
  const cacheRaw = localStorage.getItem(PERIODS_CACHE_KEY)
  const cache = cacheRaw === null ? undefined : parseJsonIfValid(cacheRaw)
  const cachedPeriods = Array.isArray(cache) ? cache : []
  // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion,sonarjs/todo-tag
  return cachedPeriods as string[] // TODO: validation
}

export const addPeriodNameToCache = (name: string) => {
  const cachedPeriods = getCachedPeriodNames()
  const newCache = Array.dedupe([name, ...cachedPeriods]).slice(0, 10)
  localStorage.setItem(PERIODS_CACHE_KEY, JSON.stringify(newCache))
}

const getSelectedPeriodsHistory = (setting: OrganizationSettingFieldsFragment, periods: Period[]): Period[] => {
  const defaultRecommended = periodUtil.getDefaultRecommended(setting).map((x) => x.name)

  const recommended = pipe(
    [...getCachedPeriodNames(), ...defaultRecommended],
    Array.dedupe,
    Array.take(10),
    Array.map((name) => periods.find((period) => period.name === name)),
    Array.filter(isNotNullish),
  )

  return recommended.map((x) => ({
    ...x,
    groupName: '履歴', // 本当はカウントなどしたいが、一旦これで十分か。
    groupNameLabel: t(`履歴`),
  }))
}

export const getPeriodsForDashboard = (setting: OrganizationSettingFieldsFragment): Period[] => {
  const periods = periodUtil.getPeriodsForDashboard(setting)

  return [...getSelectedPeriodsHistory(setting, periods), ...periods]
}

export const getPeriodsForGoalView = (setting: OrganizationSettingFieldsFragment): Period[] => {
  const periods = periodUtil.getPeriodsForGoalView(setting)

  // 基本的にダッシュボードと同じだが、以下を変更
  // ・「全期間」をださない（やるなら「目標が設定されている全ての期間」など。分かりづらいのでなしでよさそう）
  // ・履歴を表示しない（やるならダッシュボード側とkeyを変える必要）
  return periods
}
